export const PAGES = {
    SUB_CATEGORIES: 'sub_categories.show',
};

export const GROUPES = {
    USERS_IMRESSIONS: 'users_impressions',
    PAGE_VIEW: 'page_view',
    USER_ACTION: 'user_action',
};

export const SOURCES = {
    SUBCATEGORY: 'subcategory',
};

export const SUB_GROUPES = {
    CONTENT_IMPRESSION: 'content_impression',
    WEBSITE_ACTION: 'website_action',
};

export const ACTION_TYPES = {
    IMPRESSION: 'impression',
    CLICK: 'click',
};

export const SOURCE_PAGE_LOGO_MAKER_FORK = 'logo_maker_fork';

export const TRACKING_STATIC_CONTEXT = {
    feature: {
        name: 'logo_maker',
        parent_name: 'makers_project',
    },
    publisher: {
        domain: 'buyers',
        sub_domain: 'spiders',
    },
    out_of_session: false,
};
